import React from 'react';
import Home from './pages/Home';
import './App.css';

function App() {
    return (
      <div>
        <Home/>
      </div>
    )
}

export default App;
